import { QueryClient } from "@tanstack/react-query";

// App-wide React Query client. Tests must use createTestQueryClient() — never this.
// See docs/ReactClientConventions.md §6.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20_000, // 20s — overridden per-query when needed
      refetchOnWindowFocus: false, // WS pushes real-time updates
      retry: 1,
    },
    mutations: { retry: 0 },
  },
});
